import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FormField from '../FormField';
import { Validator } from 'cat-ecommerce-alloy';
import PhoneNumberInput from '../PhoneNumberInput';
import Conditional from '@app/components/common/Conditional';

const PhoneField = ({
  showPhoneNumber,
  showVerification,
  isPhoneRequiredFlag,
  selectedCountry,
  handleValueFromSessionStorage,
  valuefromSessionStorage
}) => {
  const [t] = useTranslation();

  const getPhoneValidator = useCallback(
    currentValue => {
      return isPhoneRequiredFlag
        ? new Validator(currentValue)
            .required(t('ERROR_INVALIDPHONE'))
            .isValidPhoneNumber(t('ERROR_INVALIDPHONE'))
            .getError()
        : new Validator(currentValue)
            .isValidPhoneNumber(t('ERROR_INVALIDPHONE'))
            .getError();
    },
    [isPhoneRequiredFlag, t]
  );

  return (
    <Conditional test={showPhoneNumber}>
      {showVerification ? (
        <PhoneNumberInput
          fieldId="phone1"
          handleValueFromSessionStorage={handleValueFromSessionStorage}
          valuefromSessionStorage={valuefromSessionStorage}
          showRequired={isPhoneRequiredFlag}
          selectedCountry={selectedCountry}
        />
      ) : (
        <FormField
          fieldId="phone"
          required={isPhoneRequiredFlag}
          label={t('CAT_EMAIL_PHONE1')}
          customValidation={getPhoneValidator}
        />
      )}
    </Conditional>
  );
};

PhoneField.propTypes = {
  showPhoneNumber: PropTypes.bool,
  showVerification: PropTypes.bool,
  isPhoneRequiredFlag: PropTypes.bool,
  selectedCountry: PropTypes.string,
  handleValueFromSessionStorage: PropTypes.bool,
  valuefromSessionStorage: PropTypes.shape({})
};

export default PhoneField;
